export const customers = [
  {name: 'Maud van den Heuvel Photography', nameUrl: 'maud-van-den-heuvel-photography', link: ''},
  {name: 'Creative Store', nameUrl: 'creative-store', link: ''},
  {name: 'Stichting Odion', nameUrl: 'stichting-odion', link: ''},
  {name: 'Hair Creations', nameUrl: 'hair-creations', link: ''},
  {name: 'Crowdsite', nameUrl: 'crowdsite', link: ''},
  {name: 'iWave Media', nameUrl: 'iwave-media', link: ''}
]
